module.exports = __webpack_public_path__ + "img/logo.c9241552.png";